import PropTypes from 'prop-types';

const taskStatusShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  sortOrder: PropTypes.number.isRequired,
});

export default taskStatusShape;
